module.exports = __webpack_public_path__ + "static/media/Windmolen.470b5cb2.mp3";